module.exports = __webpack_public_path__ + "615834bf6d99f58159f268bab52e438a.png";